'use client';

import { FormStayUpdated } from '@/components/Form/FormStayUpdated';
import { CustomComponentType, IComponentStayUpdated } from '@/types/cms';

import { FormType } from '@/components/Form/types';

export const StayUpdated = (props: IComponentStayUpdated) => {
  return (
    <FormStayUpdated
      {...props}
      componentType={CustomComponentType.form}
      type={FormType.stayUpdated}
      custom_id="StayUpdated"
      message_success="Thank you for Signing Up!"
      message_error="An error has occurred, please try again later or contact us using alternative methods"
      classes="lg:container mx-auto px-6 md:px-10"
      classes_title="text-2xl md:text-[1.75rem] leading-normal font-bold text-center lg:text-[2.25rem]"
      classes_description="text-xs md:text-sm text-center lg:leading-8"
      classes_container="md:pt-9 md:pb-20"
      classes_content="lg:max-w-[484px]"
      submit_button_text="Sign Up"
    />
  );
};
